import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
import App from "./App.vue";
import router from "./router";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(VueClipboard);

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
